import { render, staticRenderFns } from "./Plugintable.vue?vue&type=template&id=d1ee9bb4&scoped=true"
import script from "./Plugintable.vue?vue&type=script&lang=js"
export * from "./Plugintable.vue?vue&type=script&lang=js"
import style0 from "./Plugintable.vue?vue&type=style&index=0&id=d1ee9bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ee9bb4",
  null
  
)

export default component.exports